// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zpHHd {\n  background-color: var(--color-white);\n  border-bottom: 1px solid var(--border-color-default);\n  z-index: 4;\n}\n\n._0qOwF {\n  overflow: auto;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "zpHHd",
	"content": "_0qOwF"
};
export default ___CSS_LOADER_EXPORT___;
